import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {PlatformParamsProps} from "../context/UserContext";


export const getUser = async (): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'auth',
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        isEncrypted: true,
    });
}